"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorTokens = void 0;
var lodestarColors = _interopRequireWildcard(require("../system/lodestarColors"));
var _ursaColors = require("../system/ursaColors");
/*
 * This file is generated by generators/load-tokens.js and should not be manually
 * modified as those changes will be overwritten when the generator runs again.
 */

const colorTokens = [{
  name: "aqua--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.aqua300
  }
}, {
  name: "aqua--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.aqua50
  }
}, {
  name: "aqua--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.aqua100
  }
}, {
  name: "aqua--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.aqua75
  }
}, {
  name: "aqua--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.aqua400
  }
}, {
  name: "aqua--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.aqua800
  }
}, {
  name: "aqua--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.aqua600
  }
}, {
  name: "azure--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure400
  }
}, {
  name: "azure--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure75
  }
}, {
  name: "azure--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure200
  }
}, {
  name: "azure--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure100
  }
}, {
  name: "azure--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure400
  }
}, {
  name: "azure--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure800
  }
}, {
  name: "azure--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure700
  }
}, {
  name: "blue--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue300
  }
}, {
  name: "blue--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue50
  }
}, {
  name: "blue--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue100
  }
}, {
  name: "blue--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "blue--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue400
  }
}, {
  name: "blue--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue800
  }
}, {
  name: "blue--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "color--background--ai-icon-wrapper--default",
  description: "The default background for icons used in the AI Panel Experiences. Do not use this token outside of that surface.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight30,
    "ursa-light": _ursaColors.colors.indigo35
  }
}, {
  name: "color--background--destructive--default",
  description: "The default version of destructive background colors.",
  value: {
    "lodestar-light": lodestarColors.danger,
    "ursa-light": _ursaColors.colors.red400
  }
}, {
  name: "color--background--destructive--strong",
  description: "The strong version of destructive background colors.",
  value: {
    "lodestar-light": lodestarColors.dangerDark10,
    "ursa-light": _ursaColors.colors.red500
  }
}, {
  name: "color--background--destructive--stronger",
  description: "The stronger version of destructive background colors.",
  value: {
    "lodestar-light": lodestarColors.dangerDark20,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "color--background--destructive--strongest",
  description: "The strongest version of destructive background colors.",
  value: {
    "lodestar-light": lodestarColors.dangerDark30,
    "ursa-light": _ursaColors.colors.red700
  }
}, {
  name: "color--background--destructive--weak",
  description: "The weak version of destructive background colors.",
  value: {
    "lodestar-light": lodestarColors.dangerLight10,
    "ursa-light": _ursaColors.colors.red300
  }
}, {
  name: "color--background--destructive--weaker",
  description: "The weaker version of destructive background colors.",
  value: {
    "lodestar-light": lodestarColors.dangerLight20,
    "ursa-light": _ursaColors.colors.red75
  }
}, {
  name: "color--background--destructive--weakest",
  description: "The weakest version of destructive background colors.",
  value: {
    "lodestar-light": lodestarColors.dangerLight30,
    "ursa-light": _ursaColors.colors.red50
  }
}, {
  name: "color--background--error--default",
  description: "The default version of a background color to indicate an error.",
  value: {
    "lodestar-light": lodestarColors.visRedDark10,
    "ursa-light": _ursaColors.colors.red300
  }
}, {
  name: "color--background--error--weak",
  description: "The weak version of a background color to indicate an error.",
  value: {
    "lodestar-light": lodestarColors.visRedLight20,
    "ursa-light": _ursaColors.colors.red75
  }
}, {
  name: "color--background--error--weaker",
  description: "The weaker version of a background color to indicate an error.",
  value: {
    "lodestar-light": lodestarColors.visRedLight30,
    "ursa-light": _ursaColors.colors.red25
  }
}, {
  name: "color--background--info--default",
  description: "The default version of a background color to indicate info.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark10,
    "ursa-light": _ursaColors.colors.azure400
  }
}, {
  name: "color--background--info--weak",
  description: "The weak version of a background color to indicate info.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.azure75
  }
}, {
  name: "color--background--info--weaker",
  description: "The weaker version of a background color to indicate info.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight20,
    "ursa-light": _ursaColors.colors.azure25
  }
}, {
  name: "color--background--neutral--default",
  description: "The default version of neutral background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.neutral75
  }
}, {
  name: "color--background--neutral--strong",
  description: "The strong version of neutral background colors.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.neutral100
  }
}, {
  name: "color--background--neutral--stronger",
  description: "The stronger version of neutral background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.neutral200
  }
}, {
  name: "color--background--neutral--strongest",
  description: "The strongest version of neutral background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "color--background--neutral--weak",
  description: "The weak version of neutral background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.neutral60
  }
}, {
  name: "color--background--neutral--weaker",
  description: "The weaker version of neutral background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.neutral50
  }
}, {
  name: "color--background--neutral--weakest",
  description: "The weakest version of neutral background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral35
  }
}, {
  name: "color--background--neutral-inverse--default",
  description: "The default version of neutral inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.neutral600
  }
}, {
  name: "color--background--neutral-inverse--strong",
  description: "The strong version of neutral inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.neutral700
  }
}, {
  name: "color--background--neutral-inverse--stronger",
  description: "The stronger version of neutral inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral800
  }
}, {
  name: "color--background--neutral-inverse--strongest",
  description: "The strongest version of neutral inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral900
  }
}, {
  name: "color--background--neutral-inverse--weak",
  description: "The weak version of neutral inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.neutral500
  }
}, {
  name: "color--background--neutral-inverse--weaker",
  description: "The weaker version of neutral inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "color--background--neutral-inverse--weakest",
  description: "The weakest version of neutral inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.neutral200
  }
}, {
  name: "color--background--notifications--default",
  description: "The weak version of backgrounds for notifications.",
  value: {
    "lodestar-light": "vizRedDark10",
    "ursa-light": _ursaColors.colors.orange500
  }
}, {
  name: "color--background--notifications--weak",
  description: "The weak version of backgrounds for notifications.",
  value: {
    "lodestar-light": "vizBlueDark10",
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "color--background--primary--default",
  description: "The default version of primary background colors.",
  value: {
    "lodestar-light": lodestarColors.visBlue,
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "color--background--primary--strong",
  description: "The strong version of primary background colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark10,
    "ursa-light": _ursaColors.colors.blue600
  }
}, {
  name: "color--background--primary--stronger",
  description: "The stronger version of primary background colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.blue700
  }
}, {
  name: "color--background--primary--strongest",
  description: "The strongest version of primary background colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.blue800
  }
}, {
  name: "color--background--primary--weak",
  description: "The weak version of primary background colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.blue300
  }
}, {
  name: "color--background--primary--weaker",
  description: "The weaker version of primary background colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight20,
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "color--background--primary--weakest",
  description: "The weakest version of primary background colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight30,
    "ursa-light": _ursaColors.colors.blue50
  }
}, {
  name: "color--background--slate--default",
  description: "The default version of slate background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.slate75
  }
}, {
  name: "color--background--slate--strong",
  description: "The strong version of slate background colors.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.slate100
  }
}, {
  name: "color--background--slate--stronger",
  description: "The stronger version of slate background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.slate200
  }
}, {
  name: "color--background--slate--strongest",
  description: "The strongest version of slate background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "color--background--slate--weak",
  description: "The weak version of slate background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.slate60
  }
}, {
  name: "color--background--slate--weaker",
  description: "The weaker version of slate background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "color--background--slate--weakest",
  description: "The weakest version of slate background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.slate35
  }
}, {
  name: "color--background--slate-inverse--default",
  description: "The default version of slate inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.slate600
  }
}, {
  name: "color--background--slate-inverse--strong",
  description: "The strong version of slate inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.slate700
  }
}, {
  name: "color--background--slate-inverse--stronger",
  description: "The stronger version of slate inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate800
  }
}, {
  name: "color--background--slate-inverse--strongest",
  description: "The strongest version of slate inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate900
  }
}, {
  name: "color--background--slate-inverse--weak",
  description: "The weak version of slate inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.slate500
  }
}, {
  name: "color--background--slate-inverse--weaker",
  description: "The weaker version of slate inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "color--background--slate-inverse--weakest",
  description: "The weakest version of slate inverse background colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.slate200
  }
}, {
  name: "color--background--spectrum-aqua--default",
  description: "The default version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTeal,
    "ursa-light": _ursaColors.colors.aqua300
  }
}, {
  name: "color--background--spectrum-aqua--strong",
  description: "The strong version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark10,
    "ursa-light": _ursaColors.colors.aqua500
  }
}, {
  name: "color--background--spectrum-aqua--stronger",
  description: "The stronger version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.aqua600
  }
}, {
  name: "color--background--spectrum-aqua--strongest",
  description: "The strongest version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark30,
    "ursa-light": _ursaColors.colors.aqua700
  }
}, {
  name: "color--background--spectrum-aqua--weak",
  description: "The weak version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealLight10,
    "ursa-light": _ursaColors.colors.aqua100
  }
}, {
  name: "color--background--spectrum-aqua--weaker",
  description: "The weaker version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealLight20,
    "ursa-light": _ursaColors.colors.aqua75
  }
}, {
  name: "color--background--spectrum-aqua--weakest",
  description: "The weakest version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealLight30,
    "ursa-light": _ursaColors.colors.aqua50
  }
}, {
  name: "color--background--spectrum-azure--default",
  description: "The default version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlue,
    "ursa-light": _ursaColors.colors.azure300
  }
}, {
  name: "color--background--spectrum-azure--strong",
  description: "The strong version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark10,
    "ursa-light": _ursaColors.colors.azure500
  }
}, {
  name: "color--background--spectrum-azure--stronger",
  description: "The stronger version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.azure600
  }
}, {
  name: "color--background--spectrum-azure--strongest",
  description: "The strongest version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.azure700
  }
}, {
  name: "color--background--spectrum-azure--weak",
  description: "The weak version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.azure200
  }
}, {
  name: "color--background--spectrum-azure--weaker",
  description: "The weaker version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight20,
    "ursa-light": _ursaColors.colors.azure100
  }
}, {
  name: "color--background--spectrum-azure--weakest",
  description: "The weakest version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight30,
    "ursa-light": _ursaColors.colors.azure75
  }
}, {
  name: "color--background--spectrum-blue--default",
  description: "The default version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlue,
    "ursa-light": _ursaColors.colors.blue300
  }
}, {
  name: "color--background--spectrum-blue--strong",
  description: "The strong version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark10,
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "color--background--spectrum-blue--stronger",
  description: "The stronger version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.blue600
  }
}, {
  name: "color--background--spectrum-blue--strongest",
  description: "The strongest version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.blue700
  }
}, {
  name: "color--background--spectrum-blue--weak",
  description: "The weak version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.blue100
  }
}, {
  name: "color--background--spectrum-blue--weaker",
  description: "The weaker version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight20,
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "color--background--spectrum-blue--weakest",
  description: "The weakest version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight30,
    "ursa-light": _ursaColors.colors.blue50
  }
}, {
  name: "color--background--spectrum-gold--default",
  description: "The default version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrange,
    "ursa-light": _ursaColors.colors.gold400
  }
}, {
  name: "color--background--spectrum-gold--strong",
  description: "The strong version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark10,
    "ursa-light": _ursaColors.colors.gold500
  }
}, {
  name: "color--background--spectrum-gold--stronger",
  description: "The stronger version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark20,
    "ursa-light": _ursaColors.colors.gold600
  }
}, {
  name: "color--background--spectrum-gold--strongest",
  description: "The strongest version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark30,
    "ursa-light": _ursaColors.colors.gold700
  }
}, {
  name: "color--background--spectrum-gold--weak",
  description: "The weak version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeLight10,
    "ursa-light": _ursaColors.colors.gold300
  }
}, {
  name: "color--background--spectrum-gold--weaker",
  description: "The weaker version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeLight20,
    "ursa-light": _ursaColors.colors.gold200
  }
}, {
  name: "color--background--spectrum-gold--weakest",
  description: "The weakest version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeLight30,
    "ursa-light": _ursaColors.colors.gold100
  }
}, {
  name: "color--background--spectrum-green--default",
  description: "The default version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreen,
    "ursa-light": _ursaColors.colors.green300
  }
}, {
  name: "color--background--spectrum-green--strong",
  description: "The strong version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenDark10,
    "ursa-light": _ursaColors.colors.green500
  }
}, {
  name: "color--background--spectrum-green--stronger",
  description: "The stronger version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenDark20,
    "ursa-light": _ursaColors.colors.green600
  }
}, {
  name: "color--background--spectrum-green--strongest",
  description: "The strongest version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenDark30,
    "ursa-light": _ursaColors.colors.green700
  }
}, {
  name: "color--background--spectrum-green--weak",
  description: "The weak version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenLight10,
    "ursa-light": _ursaColors.colors.green100
  }
}, {
  name: "color--background--spectrum-green--weaker",
  description: "The weaker version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenLight20,
    "ursa-light": _ursaColors.colors.green75
  }
}, {
  name: "color--background--spectrum-green--weakest",
  description: "The weakest version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenLight30,
    "ursa-light": _ursaColors.colors.green50
  }
}, {
  name: "color--background--spectrum-indigo--default",
  description: "The default version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurple,
    "ursa-light": _ursaColors.colors.indigo300
  }
}, {
  name: "color--background--spectrum-indigo--strong",
  description: "The strong version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark10,
    "ursa-light": _ursaColors.colors.indigo500
  }
}, {
  name: "color--background--spectrum-indigo--stronger",
  description: "The stronger version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark20,
    "ursa-light": _ursaColors.colors.indigo600
  }
}, {
  name: "color--background--spectrum-indigo--strongest",
  description: "The strongest version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark30,
    "ursa-light": _ursaColors.colors.indigo700
  }
}, {
  name: "color--background--spectrum-indigo--weak",
  description: "The weak version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight10,
    "ursa-light": _ursaColors.colors.indigo100
  }
}, {
  name: "color--background--spectrum-indigo--weaker",
  description: "The weaker version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight20,
    "ursa-light": _ursaColors.colors.indigo75
  }
}, {
  name: "color--background--spectrum-indigo--weakest",
  description: "The weakest version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight30,
    "ursa-light": _ursaColors.colors.indigo50
  }
}, {
  name: "color--background--spectrum-mint--default",
  description: "The default version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.success,
    "ursa-light": _ursaColors.colors.mint300
  }
}, {
  name: "color--background--spectrum-mint--strong",
  description: "The strong version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successDark10,
    "ursa-light": _ursaColors.colors.mint500
  }
}, {
  name: "color--background--spectrum-mint--stronger",
  description: "The stronger version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successDark20,
    "ursa-light": _ursaColors.colors.mint600
  }
}, {
  name: "color--background--spectrum-mint--strongest",
  description: "The strongest version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successDark30,
    "ursa-light": _ursaColors.colors.mint700
  }
}, {
  name: "color--background--spectrum-mint--weak",
  description: "The weak version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successLight10,
    "ursa-light": _ursaColors.colors.mint100
  }
}, {
  name: "color--background--spectrum-mint--weaker",
  description: "The weaker version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successLight20,
    "ursa-light": _ursaColors.colors.mint75
  }
}, {
  name: "color--background--spectrum-mint--weakest",
  description: "The weakest version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successLight30,
    "ursa-light": _ursaColors.colors.mint50
  }
}, {
  name: "color--background--spectrum-neutral--default",
  description: "The default version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "color--background--spectrum-neutral--strong",
  description: "The strong version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.neutral500
  }
}, {
  name: "color--background--spectrum-neutral--stronger",
  description: "The stronger version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.neutral600
  }
}, {
  name: "color--background--spectrum-neutral--strongest",
  description: "The strongest version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral700
  }
}, {
  name: "color--background--spectrum-neutral--weak",
  description: "The weak version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.neutral100
  }
}, {
  name: "color--background--spectrum-neutral--weaker",
  description: "The weaker version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.neutral75
  }
}, {
  name: "color--background--spectrum-neutral--weakest",
  description: "The weakest version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.neutral50
  }
}, {
  name: "color--background--spectrum-orange--default",
  description: "The default version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrange,
    "ursa-light": _ursaColors.colors.orange300
  }
}, {
  name: "color--background--spectrum-orange--strong",
  description: "The strong version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark10,
    "ursa-light": _ursaColors.colors.orange500
  }
}, {
  name: "color--background--spectrum-orange--stronger",
  description: "The stronger version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark20,
    "ursa-light": _ursaColors.colors.orange600
  }
}, {
  name: "color--background--spectrum-orange--strongest",
  description: "The strongest version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark30,
    "ursa-light": _ursaColors.colors.orange700
  }
}, {
  name: "color--background--spectrum-orange--weak",
  description: "The weak version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeLight10,
    "ursa-light": _ursaColors.colors.orange200
  }
}, {
  name: "color--background--spectrum-orange--weaker",
  description: "The weaker version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeLight20,
    "ursa-light": _ursaColors.colors.orange100
  }
}, {
  name: "color--background--spectrum-orange--weakest",
  description: "The weakest version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeLight30,
    "ursa-light": _ursaColors.colors.orange75
  }
}, {
  name: "color--background--spectrum-orchid--default",
  description: "The default version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerry,
    "ursa-light": _ursaColors.colors.orchid300
  }
}, {
  name: "color--background--spectrum-orchid--strong",
  description: "The strong version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark10,
    "ursa-light": _ursaColors.colors.orchid500
  }
}, {
  name: "color--background--spectrum-orchid--stronger",
  description: "The stronger version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.orchid600
  }
}, {
  name: "color--background--spectrum-orchid--strongest",
  description: "The strongest version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.orchid700
  }
}, {
  name: "color--background--spectrum-orchid--weak",
  description: "The weak version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight10,
    "ursa-light": _ursaColors.colors.orchid100
  }
}, {
  name: "color--background--spectrum-orchid--weaker",
  description: "The weaker version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight20,
    "ursa-light": _ursaColors.colors.orchid75
  }
}, {
  name: "color--background--spectrum-orchid--weakest",
  description: "The weakest version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight30,
    "ursa-light": _ursaColors.colors.orchid50
  }
}, {
  name: "color--background--spectrum-pink--default",
  description: "The default version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerry,
    "ursa-light": _ursaColors.colors.pink300
  }
}, {
  name: "color--background--spectrum-pink--strong",
  description: "The strong version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark10,
    "ursa-light": _ursaColors.colors.pink500
  }
}, {
  name: "color--background--spectrum-pink--stronger",
  description: "The stronger version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.pink600
  }
}, {
  name: "color--background--spectrum-pink--strongest",
  description: "The strongest version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.pink700
  }
}, {
  name: "color--background--spectrum-pink--weak",
  description: "The weak version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight10,
    "ursa-light": _ursaColors.colors.pink100
  }
}, {
  name: "color--background--spectrum-pink--weaker",
  description: "The weaker version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight20,
    "ursa-light": _ursaColors.colors.pink75
  }
}, {
  name: "color--background--spectrum-pink--weakest",
  description: "The weakest version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight30,
    "ursa-light": _ursaColors.colors.pink50
  }
}, {
  name: "color--background--spectrum-red--default",
  description: "The default version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRed,
    "ursa-light": _ursaColors.colors.red300
  }
}, {
  name: "color--background--spectrum-red--strong",
  description: "The strong version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedDark10,
    "ursa-light": _ursaColors.colors.red500
  }
}, {
  name: "color--background--spectrum-red--stronger",
  description: "The stronger version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedDark20,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "color--background--spectrum-red--strongest",
  description: "The strongest version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedDark30,
    "ursa-light": _ursaColors.colors.red700
  }
}, {
  name: "color--background--spectrum-red--weak",
  description: "The weak version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedLight10,
    "ursa-light": _ursaColors.colors.red100
  }
}, {
  name: "color--background--spectrum-red--weaker",
  description: "The weaker version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedLight20,
    "ursa-light": _ursaColors.colors.red75
  }
}, {
  name: "color--background--spectrum-red--weakest",
  description: "The weakest version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedLight30,
    "ursa-light": _ursaColors.colors.red50
  }
}, {
  name: "color--background--spectrum-rose--default",
  description: "The default version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerry,
    "ursa-light": _ursaColors.colors.rose300
  }
}, {
  name: "color--background--spectrum-rose--strong",
  description: "The strong version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark10,
    "ursa-light": _ursaColors.colors.rose500
  }
}, {
  name: "color--background--spectrum-rose--stronger",
  description: "The stronger version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.rose600
  }
}, {
  name: "color--background--spectrum-rose--strongest",
  description: "The strongest version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.rose700
  }
}, {
  name: "color--background--spectrum-rose--weak",
  description: "The weak version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight10,
    "ursa-light": _ursaColors.colors.rose100
  }
}, {
  name: "color--background--spectrum-rose--weaker",
  description: "The weaker version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight20,
    "ursa-light": _ursaColors.colors.rose75
  }
}, {
  name: "color--background--spectrum-rose--weakest",
  description: "The weakest version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryLight30,
    "ursa-light": _ursaColors.colors.rose50
  }
}, {
  name: "color--background--spectrum-slate--default",
  description: "The default version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "color--background--spectrum-slate--strong",
  description: "The strong version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.slate500
  }
}, {
  name: "color--background--spectrum-slate--stronger",
  description: "The stronger version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.slate600
  }
}, {
  name: "color--background--spectrum-slate--strongest",
  description: "The strongest version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate700
  }
}, {
  name: "color--background--spectrum-slate--weak",
  description: "The weak version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.slate100
  }
}, {
  name: "color--background--spectrum-slate--weaker",
  description: "The weaker version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.slate75
  }
}, {
  name: "color--background--spectrum-slate--weakest",
  description: "The weakest version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "color--background--spectrum-teal--default",
  description: "The default version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTeal,
    "ursa-light": _ursaColors.colors.teal300
  }
}, {
  name: "color--background--spectrum-teal--strong",
  description: "The strong version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark10,
    "ursa-light": _ursaColors.colors.teal500
  }
}, {
  name: "color--background--spectrum-teal--stronger",
  description: "The stronger version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.teal600
  }
}, {
  name: "color--background--spectrum-teal--strongest",
  description: "The strongest version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark30,
    "ursa-light": _ursaColors.colors.teal700
  }
}, {
  name: "color--background--spectrum-teal--weak",
  description: "The weak version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealLight10,
    "ursa-light": _ursaColors.colors.teal100
  }
}, {
  name: "color--background--spectrum-teal--weaker",
  description: "The weaker version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealLight20,
    "ursa-light": _ursaColors.colors.teal75
  }
}, {
  name: "color--background--spectrum-teal--weakest",
  description: "The weakest version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealLight30,
    "ursa-light": _ursaColors.colors.teal50
  }
}, {
  name: "color--background--spectrum-violet--default",
  description: "The default version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurple,
    "ursa-light": _ursaColors.colors.violet300
  }
}, {
  name: "color--background--spectrum-violet--strong",
  description: "The strong version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark10,
    "ursa-light": _ursaColors.colors.violet500
  }
}, {
  name: "color--background--spectrum-violet--stronger",
  description: "The stronger version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark20,
    "ursa-light": _ursaColors.colors.violet600
  }
}, {
  name: "color--background--spectrum-violet--strongest",
  description: "The strongest version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark30,
    "ursa-light": _ursaColors.colors.violet700
  }
}, {
  name: "color--background--spectrum-violet--weak",
  description: "The weak version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight10,
    "ursa-light": _ursaColors.colors.violet100
  }
}, {
  name: "color--background--spectrum-violet--weaker",
  description: "The weaker version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight20,
    "ursa-light": _ursaColors.colors.violet75
  }
}, {
  name: "color--background--spectrum-violet--weakest",
  description: "The weakest version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight30,
    "ursa-light": _ursaColors.colors.violet50
  }
}, {
  name: "color--background--spectrum-yellow--default",
  description: "The default version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellow,
    "ursa-light": _ursaColors.colors.yellow400
  }
}, {
  name: "color--background--spectrum-yellow--strong",
  description: "The strong version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowDark10,
    "ursa-light": _ursaColors.colors.yellow500
  }
}, {
  name: "color--background--spectrum-yellow--stronger",
  description: "The stronger version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowDark20,
    "ursa-light": _ursaColors.colors.yellow600
  }
}, {
  name: "color--background--spectrum-yellow--strongest",
  description: "The strongest version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowDark30,
    "ursa-light": _ursaColors.colors.yellow700
  }
}, {
  name: "color--background--spectrum-yellow--weak",
  description: "The weak version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowLight10,
    "ursa-light": _ursaColors.colors.yellow300
  }
}, {
  name: "color--background--spectrum-yellow--weaker",
  description: "The weaker version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowLight20,
    "ursa-light": _ursaColors.colors.yellow200
  }
}, {
  name: "color--background--spectrum-yellow--weakest",
  description: "The weakest version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowLight30,
    "ursa-light": _ursaColors.colors.yellow100
  }
}, {
  name: "color--background--success--default",
  description: "The default version of a background color to indicate success.",
  value: {
    "lodestar-light": lodestarColors.successDark10,
    "ursa-light": _ursaColors.colors.mint300
  }
}, {
  name: "color--background--success--weak",
  description: "The weak version of a background color to indicate success.",
  value: {
    "lodestar-light": lodestarColors.successLight20,
    "ursa-light": _ursaColors.colors.mint50
  }
}, {
  name: "color--background--success--weaker",
  description: "The weaker version of a background color to indicate success.",
  value: {
    "lodestar-light": lodestarColors.successLight30,
    "ursa-light": _ursaColors.colors.mint25
  }
}, {
  name: "color--background--surfaces--body",
  description: "The background color for the document body.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--background--surfaces--canvas",
  description: "The background color for the canvas surface.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.slate25
  }
}, {
  name: "color--background--surfaces--overlay",
  description: "The background color for the overlay.",
  value: {
    "lodestar-light": lodestarColors.blanketBackground,
    "ursa-light": "rgba(36, 39, 50, 0.08)"
  }
}, {
  name: "color--background--surfaces--stage",
  description: "The background color for the stage surface.",
  value: {
    "lodestar-light": lodestarColors.neutralDark40,
    "ursa-light": _ursaColors.colors.neutral700
  }
}, {
  name: "color--background--surfaces--work",
  description: "The background color the work surface.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--background--warning--default",
  description: "The default version of a background color to indicate a warning.",
  value: {
    "lodestar-light": lodestarColors.warningDark10,
    "ursa-light": _ursaColors.colors.gold600
  }
}, {
  name: "color--background--warning--weak",
  description: "The weak version of a background color to indicate a warning.",
  value: {
    "lodestar-light": lodestarColors.warningLight20,
    "ursa-light": _ursaColors.colors.gold75
  }
}, {
  name: "color--background--warning--weaker",
  description: "The weaker version of a background color to indicate a warning.",
  value: {
    "lodestar-light": lodestarColors.warningLight30,
    "ursa-light": _ursaColors.colors.gold25
  }
}, {
  name: "color--border--error--default",
  description: "The default border to indicate an error.",
  value: {
    "lodestar-light": lodestarColors.danger,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "color--border--neutral--default",
  description: "The default neutral color border.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "color--border--neutral--strong",
  description: "The strong neutral color border.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.neutral500
  }
}, {
  name: "color--border--neutral--stronger",
  description: "The stronger neutral color border.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.neutral700
  }
}, {
  name: "color--border--neutral--strongest",
  description: "The strongest neutral color border.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral900
  }
}, {
  name: "color--border--neutral--weak",
  description: "The weak neutral color border.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.neutral200
  }
}, {
  name: "color--border--neutral--weaker",
  description: "The weaker neutral color border.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.neutral75
  }
}, {
  name: "color--border--neutral--weakest",
  description: "The weakest neutral color border.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.neutral50
  }
}, {
  name: "color--border--primary--default",
  description: "The weakest primary color border.",
  value: {
    "lodestar-light": lodestarColors.visBlue,
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "color--border--primary--weak",
  description: "The weak primary color border.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.blue300
  }
}, {
  name: "color--border--primary--weaker",
  description: "The weaker primary color border.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight20,
    "ursa-light": _ursaColors.colors.blue100
  }
}, {
  name: "color--border--primary--weakest",
  description: "The weakest primary color border.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight30,
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "color--border--slate--default",
  description: "The default slate color border.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "color--border--slate--strong",
  description: "The strong slate color border.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.slate500
  }
}, {
  name: "color--border--slate--stronger",
  description: "The stronger slate color border.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.slate700
  }
}, {
  name: "color--border--slate--strongest",
  description: "The strongest slate color border.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate900
  }
}, {
  name: "color--border--slate--weak",
  description: "The weak slate color border.",
  value: {
    "lodestar-light": lodestarColors.neutralLight10,
    "ursa-light": _ursaColors.colors.slate200
  }
}, {
  name: "color--border--slate--weaker",
  description: "The weaker slate color border.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.slate75
  }
}, {
  name: "color--border--slate--weakest",
  description: "The weakest slate color border.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "color--border--spectrum-aqua--default",
  description: "The border color for spectrum aqua. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.aqua600
  }
}, {
  name: "color--border--spectrum-azure--default",
  description: "The border color for spectrum azure. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.azure700
  }
}, {
  name: "color--border--spectrum-blue--default",
  description: "The border color for spectrum blue. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.blue600
  }
}, {
  name: "color--border--spectrum-default--default",
  description: "The border color for spectrum slate. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.slate600
  }
}, {
  name: "color--border--spectrum-gold--default",
  description: "The border color for spectrum gold. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.warningDark20,
    "ursa-light": _ursaColors.colors.gold600
  }
}, {
  name: "color--border--spectrum-green--default",
  description: "The border color for spectrum green. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenDark20,
    "ursa-light": _ursaColors.colors.green600
  }
}, {
  name: "color--border--spectrum-indigo--default",
  description: "The border color for spectrum indigo. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark20,
    "ursa-light": _ursaColors.colors.indigo600
  }
}, {
  name: "color--border--spectrum-mint--default",
  description: "The border color for spectrum mint. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successDark20,
    "ursa-light": _ursaColors.colors.mint600
  }
}, {
  name: "color--border--spectrum-neutral--default",
  description: "The border color for spectrum neutral. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.neutral600
  }
}, {
  name: "color--border--spectrum-orange--default",
  description: "The border color for spectrum orange. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.warningDark20,
    "ursa-light": _ursaColors.colors.orange700
  }
}, {
  name: "color--border--spectrum-orchid--default",
  description: "The border color for spectrum orchid. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.orchid600
  }
}, {
  name: "color--border--spectrum-pink--default",
  description: "The border color for spectrum pink. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.pink600
  }
}, {
  name: "color--border--spectrum-red--default",
  description: "The border color for spectrum red. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.dangerDark20,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "color--border--spectrum-rose--default",
  description: "The border color for spectrum rose. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.rose600
  }
}, {
  name: "color--border--spectrum-teal--default",
  description: "The border color for spectrum teal. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.teal600
  }
}, {
  name: "color--border--spectrum-violet--default",
  description: "The border color for spectrum violet. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark20,
    "ursa-light": _ursaColors.colors.violet600
  }
}, {
  name: "color--border--spectrum-yellow--default",
  description: "The border color for spectrum yellow. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowDark20,
    "ursa-light": _ursaColors.colors.yellow700
  }
}, {
  name: "color--border--success--default",
  description: "The default border to indicate success.",
  value: {
    "lodestar-light": lodestarColors.success,
    "ursa-light": _ursaColors.colors.mint600
  }
}, {
  name: "color--border--surfaces--body",
  description: "The border color that matches the document body.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--border--surfaces--canvas",
  description: "The border color that matches the canvas surface.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.slate25
  }
}, {
  name: "color--border--surfaces--focus",
  description: "The border color for focus",
  value: {
    "lodestar-light": lodestarColors.visBlue,
    "ursa-light": _ursaColors.colors.blue400
  }
}, {
  name: "color--border--surfaces--stage",
  description: "The border color that matches the stage surface.",
  value: {
    "lodestar-light": lodestarColors.neutralDark40,
    "ursa-light": _ursaColors.colors.neutral700
  }
}, {
  name: "color--border--surfaces--work",
  description: "The border color that matches the work surface.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--border--warning--default",
  description: "The default border to indicate a warning.",
  value: {
    "lodestar-light": lodestarColors.warning,
    "ursa-light": _ursaColors.colors.gold600
  }
}, {
  name: "color--icons--destructive--default",
  description: "The default version of destructive for icons.",
  value: {
    "lodestar-light": lodestarColors.visRed,
    "ursa-light": _ursaColors.colors.red400
  }
}, {
  name: "color--icons--destructive--strong",
  description: "The strong version of destructive for icons.",
  value: {
    "lodestar-light": lodestarColors.visRedDark10,
    "ursa-light": _ursaColors.colors.red500
  }
}, {
  name: "color--icons--destructive--stronger",
  description: "The stronger version of destructive for icons.",
  value: {
    "lodestar-light": lodestarColors.visRedDark20,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "color--icons--destructive--strongest",
  description: "The strongest version of destructive for icons.",
  value: {
    "lodestar-light": lodestarColors.visRedDark30,
    "ursa-light": _ursaColors.colors.red900
  }
}, {
  name: "color--icons--destructive--weak",
  description: "The weak version of destructive for icons.",
  value: {
    "lodestar-light": lodestarColors.visRedLight10,
    "ursa-light": _ursaColors.colors.red300
  }
}, {
  name: "color--icons--destructive--weaker",
  description: "The weaker version of destructive for icons.",
  value: {
    "lodestar-light": lodestarColors.visRedLight20,
    "ursa-light": _ursaColors.colors.red200
  }
}, {
  name: "color--icons--destructive--weakest",
  description: "The weakest version of destructive for icons.",
  value: {
    "lodestar-light": lodestarColors.visRedLight30,
    "ursa-light": _ursaColors.colors.red75
  }
}, {
  name: "color--icons--destructive-inverse--stronger",
  description: "The stronger version of destructive inverse icons.",
  value: {
    "lodestar-light": lodestarColors.visRedLight30,
    "ursa-light": _ursaColors.colors.red25
  }
}, {
  name: "color--icons--error--default",
  description: "The default version of error icons. Used for icons that denote an error.",
  value: {
    "lodestar-light": lodestarColors.dangerDark20,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "color--icons--error--weak",
  description: "The weak version of error icons. Used for icons that denote an error.",
  value: {
    "lodestar-light": lodestarColors.danger,
    "ursa-light": _ursaColors.colors.red300
  }
}, {
  name: "color--icons--info--default",
  description: "The default version of info icons. Used for icons that denote information.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.azure600
  }
}, {
  name: "color--icons--info--weak",
  description: "The weak version of info icons. Used for icons that denote information.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark10,
    "ursa-light": _ursaColors.colors.blue200
  }
}, {
  name: "color--icons--neutral--default",
  description: "The default version of neutral for icons.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.neutral400
  }
}, {
  name: "color--icons--neutral--strong",
  description: "The strong version of neutral for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.neutral500
  }
}, {
  name: "color--icons--neutral--stronger",
  description: "The stronger version of neutral for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.neutral600
  }
}, {
  name: "color--icons--neutral--strongest",
  description: "The strongest version of neutral for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral900
  }
}, {
  name: "color--icons--neutral--weak",
  description: "The weak version of neutral for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "color--icons--neutral--weaker",
  description: "The weaker version of neutral for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.neutral200
  }
}, {
  name: "color--icons--neutral--weakest",
  description: "The weakest version of neutral for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.neutral75
  }
}, {
  name: "color--icons--neutral-inverse--default",
  description: "The default version of neutral inverse for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--icons--neutral-inverse--weak",
  description: "The weaker version of neutral inverse for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.neutral60
  }
}, {
  name: "color--icons--primary--default",
  description: "The default version of primary icons.",
  value: {
    "lodestar-light": lodestarColors.visBlue,
    "ursa-light": _ursaColors.colors.blue400
  }
}, {
  name: "color--icons--primary--strong",
  description: "The strong version of primary icons.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark10,
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "color--icons--primary--stronger",
  description: "The stronger version of primary icons.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.blue600
  }
}, {
  name: "color--icons--primary--strongest",
  description: "The strongest version of primary icons.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.blue900
  }
}, {
  name: "color--icons--primary--weak",
  description: "The weak version of primary icons.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.blue300
  }
}, {
  name: "color--icons--primary--weaker",
  description: "The weaker version of primary icons.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight20,
    "ursa-light": _ursaColors.colors.blue200
  }
}, {
  name: "color--icons--primary--weakest",
  description: "The weakest version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight30,
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "color--icons--primary-inverse--stronger",
  description: "The stronger version of primary inverse icons",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.blue25
  }
}, {
  name: "color--icons--slate--default",
  description: "The default version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.slate400
  }
}, {
  name: "color--icons--slate--strong",
  description: "The strong version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.slate500
  }
}, {
  name: "color--icons--slate--stronger",
  description: "The stronger version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.slate600
  }
}, {
  name: "color--icons--slate--strongest",
  description: "The strongest version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate900
  }
}, {
  name: "color--icons--slate--weak",
  description: "The weak version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "color--icons--slate--weaker",
  description: "The weaker version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.slate200
  }
}, {
  name: "color--icons--slate--weakest",
  description: "The weakest version of slate for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.slate75
  }
}, {
  name: "color--icons--slate-inverse--default",
  description: "The default version of slate inverse for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--icons--slate-inverse--weak",
  description: "The weak version of slate inverse for icons.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.slate60
  }
}, {
  name: "color--icons--spectrum-aqua--default",
  description: "The default version of spectrum aqua for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.aqua800
  }
}, {
  name: "color--icons--spectrum-azure--default",
  description: "The default version of spectrum azure for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.azure800
  }
}, {
  name: "color--icons--spectrum-blue--default",
  description: "The default version of spectrum blue for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.blue800
  }
}, {
  name: "color--icons--spectrum-gold--default",
  description: "The default version of spectrum gold for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark20,
    "ursa-light": _ursaColors.colors.gold800
  }
}, {
  name: "color--icons--spectrum-green--default",
  description: "The default version of spectrum green for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenDark30,
    "ursa-light": _ursaColors.colors.green800
  }
}, {
  name: "color--icons--spectrum-indigo--default",
  description: "The default version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark30,
    "ursa-light": _ursaColors.colors.indigo800
  }
}, {
  name: "color--icons--spectrum-indigo--weak",
  description: "The weak version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark10,
    "ursa-light": _ursaColors.colors.indigo500
  }
}, {
  name: "color--icons--spectrum-indigo--weaker",
  description: "The weaker version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight10,
    "ursa-light": _ursaColors.colors.indigo300
  }
}, {
  name: "color--icons--spectrum-indigo--weakest",
  description: "The weakest version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleLight20,
    "ursa-light": _ursaColors.colors.indigo100
  }
}, {
  name: "color--icons--spectrum-mint--default",
  description: "The default version of spectrum mint for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successDark30,
    "ursa-light": _ursaColors.colors.mint800
  }
}, {
  name: "color--icons--spectrum-neutral--default",
  description: "The default version of spectrum neutral for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral800
  }
}, {
  name: "color--icons--spectrum-orange--default",
  description: "The default version of spectrum orange for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark20,
    "ursa-light": _ursaColors.colors.orange800
  }
}, {
  name: "color--icons--spectrum-orchid--default",
  description: "The default version of spectrum orchid for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.orchid800
  }
}, {
  name: "color--icons--spectrum-pink--default",
  description: "The default version of spectrum pink for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.pink800
  }
}, {
  name: "color--icons--spectrum-red--default",
  description: "The default version of spectrum red for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedDark30,
    "ursa-light": _ursaColors.colors.red800
  }
}, {
  name: "color--icons--spectrum-rose--default",
  description: "The default version of spectrum rose for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.rose800
  }
}, {
  name: "color--icons--spectrum-slate--default",
  description: "The default version of spectrum slate for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate800
  }
}, {
  name: "color--icons--spectrum-teal--default",
  description: "The default version of spectrum teal for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.teal800
  }
}, {
  name: "color--icons--spectrum-violet--default",
  description: "The default version of spectrum violet for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark30,
    "ursa-light": _ursaColors.colors.violet800
  }
}, {
  name: "color--icons--spectrum-yellow--default",
  description: "The default version of spectrum yellow for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowDark20,
    "ursa-light": _ursaColors.colors.yellow800
  }
}, {
  name: "color--icons--success--default",
  description: "The default version of success icons. Used for icons that denote success.",
  value: {
    "lodestar-light": lodestarColors.successDark20,
    "ursa-light": _ursaColors.colors.mint600
  }
}, {
  name: "color--icons--success--weak",
  description: "The weak version of success icons. Used for icons that denote success.",
  value: {
    "lodestar-light": lodestarColors.successDark10,
    "ursa-light": _ursaColors.colors.mint300
  }
}, {
  name: "color--icons--warning--default",
  description: "The default version of warning icons. Used for icons that denote information.",
  value: {
    "lodestar-light": lodestarColors.warningDark20,
    "ursa-light": _ursaColors.colors.gold700
  }
}, {
  name: "color--icons--warning--weak",
  description: "The weak version of warning icons. Used for icons that denote information.",
  value: {
    "lodestar-light": lodestarColors.warning,
    "ursa-light": _ursaColors.colors.gold300
  }
}, {
  name: "color--text--error--default",
  description: "The default version of error text colors. Used on error text.",
  value: {
    "lodestar-light": lodestarColors.visRedDark30,
    "ursa-light": _ursaColors.colors.red800
  }
}, {
  name: "color--text--error--weak",
  description: "The weak version of error text colors. Used on error text.",
  value: {
    "lodestar-light": lodestarColors.visRedDark20,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "color--text--info--default",
  description: "The default version of info text colors. Used on info text.",
  value: {
    "lodestar-light": lodestarColors.infoDark30,
    "ursa-light": _ursaColors.colors.azure800
  }
}, {
  name: "color--text--info--weak",
  description: "The weak version of info text colors. Used on info text.",
  value: {
    "lodestar-light": lodestarColors.infoDark20,
    "ursa-light": _ursaColors.colors.azure700
  }
}, {
  name: "color--text--neutral--default",
  description: "The default version of neutral text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral700
  }
}, {
  name: "color--text--neutral--strong",
  description: "The strong version of neutral text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark40,
    "ursa-light": _ursaColors.colors.neutral800
  }
}, {
  name: "color--text--neutral--weak",
  description: "The weak version of neutral text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.neutral500
  }
}, {
  name: "color--text--neutral--weaker",
  description: "The weaker version of neutral text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.neutral400
  }
}, {
  name: "color--text--neutral--weakest",
  description: "The weakest version of neutral text colors.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "color--text--neutral-inverse--default",
  description: "The weaker version of neutral inverse text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.neutral25
  }
}, {
  name: "color--text--neutral-inverse--strong",
  description: "The weak version of neutral inverse text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--text--neutral-inverse--weak",
  description: "The weakest version of neutral inverse text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.neutral50
  }
}, {
  name: "color--text--primary--default",
  description: "The default version of primary text colors.",
  value: {
    "lodestar-light": lodestarColors.visBlue,
    "ursa-light": _ursaColors.colors.blue600
  }
}, {
  name: "color--text--primary--strong",
  description: "The strong version of primary text colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark10,
    "ursa-light": _ursaColors.colors.blue700
  }
}, {
  name: "color--text--primary--stronger",
  description: "The stronger version of primary text colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.blue800
  }
}, {
  name: "color--text--primary--strongest",
  description: "The strongest version of primary text colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.blue900
  }
}, {
  name: "color--text--primary--weak",
  description: "The weak version of primary text colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight10,
    "ursa-light": _ursaColors.colors.blue300
  }
}, {
  name: "color--text--primary--weaker",
  description: "The weaker version of primary text colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight20,
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "color--text--primary--weakest",
  description: "The weakest version of primary text colors.",
  value: {
    "lodestar-light": lodestarColors.visBlueLight30,
    "ursa-light": _ursaColors.colors.blue25
  }
}, {
  name: "color--text--slate--default",
  description: "The default version of slate text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate700
  }
}, {
  name: "color--text--slate--strong",
  description: "The strong version of slate text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark40,
    "ursa-light": _ursaColors.colors.slate800
  }
}, {
  name: "color--text--slate--weak",
  description: "The weak version of slate text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.slate500
  }
}, {
  name: "color--text--slate--weaker",
  description: "The weaker version of slate text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralDark10,
    "ursa-light": _ursaColors.colors.slate400
  }
}, {
  name: "color--text--slate--weakest",
  description: "The weakest version of slate text colors.",
  value: {
    "lodestar-light": lodestarColors.neutral,
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "color--text--slate-inverse--default",
  description: "The default version of slate inverse text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight30,
    "ursa-light": _ursaColors.colors.slate25
  }
}, {
  name: "color--text--slate-inverse--strong",
  description: "The strong version of slate inverse text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "color--text--slate-inverse--weak",
  description: "The weak version of slate inverse text colors.",
  value: {
    "lodestar-light": lodestarColors.neutralLight20,
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "color--text--spectrum-aqua--default",
  description: "The default version of spectrum aqua for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.aqua800
  }
}, {
  name: "color--text--spectrum-aqua--strong",
  description: "The strong version of spectrum aqua for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark30,
    "ursa-light": _ursaColors.colors.aqua900
  }
}, {
  name: "color--text--spectrum-azure--default",
  description: "The default version of spectrum azure for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.azure800
  }
}, {
  name: "color--text--spectrum-azure--strong",
  description: "The strong version of spectrum azure for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.azure900
  }
}, {
  name: "color--text--spectrum-blue--default",
  description: "The default version of spectrum blue for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark20,
    "ursa-light": _ursaColors.colors.blue800
  }
}, {
  name: "color--text--spectrum-blue--strong",
  description: "The strong version of spectrum blue for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBlueDark30,
    "ursa-light": _ursaColors.colors.blue900
  }
}, {
  name: "color--text--spectrum-gold--default",
  description: "The default version of spectrum gold for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark20,
    "ursa-light": _ursaColors.colors.gold800
  }
}, {
  name: "color--text--spectrum-gold--strong",
  description: "The strong version of spectrum gold for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark30,
    "ursa-light": _ursaColors.colors.gold900
  }
}, {
  name: "color--text--spectrum-green--default",
  description: "The default version of spectrum green for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenDark20,
    "ursa-light": _ursaColors.colors.green800
  }
}, {
  name: "color--text--spectrum-green--strong",
  description: "The strong version of spectrum green for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visGreenDark30,
    "ursa-light": _ursaColors.colors.green900
  }
}, {
  name: "color--text--spectrum-indigo--default",
  description: "The default version of spectrum indigo for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark20,
    "ursa-light": _ursaColors.colors.indigo800
  }
}, {
  name: "color--text--spectrum-indigo--strong",
  description: "The strong version of spectrum indigo for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark30,
    "ursa-light": _ursaColors.colors.indigo900
  }
}, {
  name: "color--text--spectrum-indigo--weak",
  description: "The weak version of spectrum indigo for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark10,
    "ursa-light": _ursaColors.colors.indigo600
  }
}, {
  name: "color--text--spectrum-mint--default",
  description: "The default version of spectrum mint for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successDark20,
    "ursa-light": _ursaColors.colors.mint800
  }
}, {
  name: "color--text--spectrum-mint--strong",
  description: "The strong version of spectrum mint for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.successDark30,
    "ursa-light": _ursaColors.colors.mint900
  }
}, {
  name: "color--text--spectrum-neutral--default",
  description: "The default version of spectrum neutral for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.neutral800
  }
}, {
  name: "color--text--spectrum-neutral--strong",
  description: "The strong version of spectrum neutral for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.neutral900
  }
}, {
  name: "color--text--spectrum-orange--default",
  description: "The default version of spectrum orange for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark20,
    "ursa-light": _ursaColors.colors.orange800
  }
}, {
  name: "color--text--spectrum-orange--strong",
  description: "The strong version of spectrum orange for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visOrangeDark30,
    "ursa-light": _ursaColors.colors.orange900
  }
}, {
  name: "color--text--spectrum-orchid--default",
  description: "The default version of spectrum orchid for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.orchid800
  }
}, {
  name: "color--text--spectrum-orchid--strong",
  description: "The strong version of spectrum orchid for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.orchid900
  }
}, {
  name: "color--text--spectrum-pink--default",
  description: "The default version of spectrum pink for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.pink800
  }
}, {
  name: "color--text--spectrum-pink--strong",
  description: "The strong version of spectrum pink for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.pink900
  }
}, {
  name: "color--text--spectrum-red--default",
  description: "The default version of spectrum red for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedDark20,
    "ursa-light": _ursaColors.colors.red800
  }
}, {
  name: "color--text--spectrum-red--strong",
  description: "The strong version of spectrum red for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visRedDark30,
    "ursa-light": _ursaColors.colors.red900
  }
}, {
  name: "color--text--spectrum-rose--default",
  description: "The default version of spectrum rose for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark20,
    "ursa-light": _ursaColors.colors.rose800
  }
}, {
  name: "color--text--spectrum-rose--strong",
  description: "The strong version of spectrum rose for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visBerryDark30,
    "ursa-light": _ursaColors.colors.rose900
  }
}, {
  name: "color--text--spectrum-slate--default",
  description: "The default version of spectrum slate for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark20,
    "ursa-light": _ursaColors.colors.slate800
  }
}, {
  name: "color--text--spectrum-slate--strong",
  description: "The strong version of spectrum slate for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.neutralDark30,
    "ursa-light": _ursaColors.colors.slate900
  }
}, {
  name: "color--text--spectrum-teal--default",
  description: "The default version of spectrum teal for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark20,
    "ursa-light": _ursaColors.colors.teal800
  }
}, {
  name: "color--text--spectrum-teal--strong",
  description: "The strong version of spectrum teal for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visTealDark30,
    "ursa-light": _ursaColors.colors.teal900
  }
}, {
  name: "color--text--spectrum-violet--default",
  description: "The default version of spectrum violet for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark20,
    "ursa-light": _ursaColors.colors.violet800
  }
}, {
  name: "color--text--spectrum-violet--strong",
  description: "The strong version of spectrum violet for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visPurpleDark30,
    "ursa-light": _ursaColors.colors.violet900
  }
}, {
  name: "color--text--spectrum-yellow--default",
  description: "The default version of spectrum yellow for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowDark20,
    "ursa-light": _ursaColors.colors.yellow800
  }
}, {
  name: "color--text--spectrum-yellow--strong",
  description: "The strong version of spectrum yellow for text colors. This should only be used within special circumstances where you need the full color spectrum.",
  value: {
    "lodestar-light": lodestarColors.visYellowDark30,
    "ursa-light": _ursaColors.colors.yellow900
  }
}, {
  name: "color--text--success--default",
  description: "The default version of success text colors. Used on success text.",
  value: {
    "lodestar-light": lodestarColors.successDark30,
    "ursa-light": _ursaColors.colors.mint800
  }
}, {
  name: "color--text--success--weak",
  description: "The weak version of success text colors. Used on success text.",
  value: {
    "lodestar-light": lodestarColors.successDark20,
    "ursa-light": _ursaColors.colors.mint600
  }
}, {
  name: "color--text--warning--default",
  description: "The default version of warning text colors. Used on warning text.",
  value: {
    "lodestar-light": lodestarColors.warningDark30,
    "ursa-light": _ursaColors.colors.gold900
  }
}, {
  name: "color--text--warning--weak",
  description: "The weak version of warning text colors. Used on warning text.",
  value: {
    "lodestar-light": lodestarColors.warningDark20,
    "ursa-light": _ursaColors.colors.gold800
  }
}, {
  name: "elevation--default",
  description: "",
  value: {
    "lodestar-light": "0px 4px 16px 0px rgba(0, 0, 0, 0.12)",
    "ursa-light": "0px 4px 6px rgba(57, 61, 76, 0.12), 0px 6px 16px 6px rgba(65, 80, 139, 0.16)"
  }
}, {
  name: "elevation--high",
  description: "",
  value: {
    "lodestar-light": "0px 24px 64px rgba(0, 0, 0, 0.12)",
    "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.12), 0px 12px 24px 8px rgba(65, 80, 139, 0.2)"
  }
}, {
  name: "elevation--low",
  description: "",
  value: {
    "lodestar-light": "0px 2px 12px 0px rgba(0, 0, 0, 0.16)",
    "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.16), 0px 6px 12px rgba(65, 80, 139, 0.12)"
  }
}, {
  name: "elevation--shadow-0",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.16), 0px 6px 12px rgba(65, 80, 139, 0.12)"
  }
}, {
  name: "elevation--shadow-1",
  description: "For menus - both Menu and Select",
  value: {
    "lodestar-light": "0px 2px 12px 0px rgba(0, 0, 0, 0.16)",
    "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.16), 0px 6px 12px rgba(65, 80, 139, 0.12)"
  }
}, {
  name: "elevation--shadow-2",
  description: "Card uses this, Contact Card uses this, Pagination",
  value: {
    "lodestar-light": "0px 4px 16px 0px rgba(0, 0, 0, 0.12)",
    "ursa-light": "0px 4px 6px rgba(57, 61, 76, 0.12), 0px 6px 16px 6px rgba(65, 80, 139, 0.16)"
  }
}, {
  name: "elevation--shadow-3",
  description: "For modals, left rails",
  value: {
    "lodestar-light": "0px 24px 64px rgba(0, 0, 0, 0.12)",
    "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.12), 0px 12px 24px 8px rgba(65, 80, 139, 0.2)"
  }
}, {
  name: "focus-indicator--border-primary",
  description: "This is the main outer border for a focus ring",
  value: {
    "lodestar-light": lodestarColors.focus,
    "ursa-light": _ursaColors.colors.focus
  }
}, {
  name: "focus-indicator--border-secondary",
  description: "This inner border provides more contrast between the focused element for scenarios where the element is on a background other than the work-surface",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "form-input--border--active",
  description: "Used for form elements that have an accompanying menu or popup. When that popup is open, this color is used for the associated control's border.",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.focus
  }
}, {
  name: "form-input--border--error",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red500
  }
}, {
  name: "form-input--border--focus",
  description: "The border applied to form elements which are currently focused",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral200
  }
}, {
  name: "form-input--border--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral400
  }
}, {
  name: "form-input--border--readonly",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral75
  }
}, {
  name: "form-input--border--rest",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "gold--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold600
  }
}, {
  name: "gold--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold100
  }
}, {
  name: "gold--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold300
  }
}, {
  name: "gold--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold200
  }
}, {
  name: "gold--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold500
  }
}, {
  name: "gold--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold900
  }
}, {
  name: "gold--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold800
  }
}, {
  name: "green--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green400
  }
}, {
  name: "green--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green50
  }
}, {
  name: "green--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green100
  }
}, {
  name: "green--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green75
  }
}, {
  name: "green--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green400
  }
}, {
  name: "green--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green800
  }
}, {
  name: "green--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green600
  }
}, {
  name: "indigo--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.indigo300
  }
}, {
  name: "indigo--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.indigo50
  }
}, {
  name: "indigo--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.indigo100
  }
}, {
  name: "indigo--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.indigo75
  }
}, {
  name: "indigo--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.indigo400
  }
}, {
  name: "indigo--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.indigo800
  }
}, {
  name: "indigo--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.indigo500
  }
}, {
  name: "mint--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.mint300
  }
}, {
  name: "mint--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.mint50
  }
}, {
  name: "mint--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.mint100
  }
}, {
  name: "mint--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.mint75
  }
}, {
  name: "mint--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.mint300
  }
}, {
  name: "mint--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.mint800
  }
}, {
  name: "mint--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.mint600
  }
}, {
  name: "neutral--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "neutral--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral50
  }
}, {
  name: "neutral--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral100
  }
}, {
  name: "neutral--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral75
  }
}, {
  name: "neutral--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral300
  }
}, {
  name: "neutral--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral800
  }
}, {
  name: "neutral--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral500
  }
}, {
  name: "orange--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orange500
  }
}, {
  name: "orange--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orange75
  }
}, {
  name: "orange--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orange200
  }
}, {
  name: "orange--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orange100
  }
}, {
  name: "orange--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orange400
  }
}, {
  name: "orange--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orange900
  }
}, {
  name: "orange--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orange700
  }
}, {
  name: "orchid--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orchid300
  }
}, {
  name: "orchid--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orchid50
  }
}, {
  name: "orchid--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orchid100
  }
}, {
  name: "orchid--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orchid75
  }
}, {
  name: "orchid--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orchid400
  }
}, {
  name: "orchid--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orchid800
  }
}, {
  name: "orchid--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.orchid600
  }
}, {
  name: "pink--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.pink300
  }
}, {
  name: "pink--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.pink50
  }
}, {
  name: "pink--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.pink100
  }
}, {
  name: "pink--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.pink75
  }
}, {
  name: "pink--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.pink400
  }
}, {
  name: "pink--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.pink800
  }
}, {
  name: "pink--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.pink600
  }
}, {
  name: "red--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red300
  }
}, {
  name: "red--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red50
  }
}, {
  name: "red--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red100
  }
}, {
  name: "red--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red75
  }
}, {
  name: "red--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red400
  }
}, {
  name: "red--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red800
  }
}, {
  name: "red--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "rose--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.rose200
  }
}, {
  name: "rose--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.rose50
  }
}, {
  name: "rose--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.rose100
  }
}, {
  name: "rose--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.rose75
  }
}, {
  name: "rose--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.rose400
  }
}, {
  name: "rose--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.rose800
  }
}, {
  name: "rose--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.rose500
  }
}, {
  name: "selection--border",
  description: "Default select border",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "selection--border-alt",
  description: "Card hover",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "selection--border-glow",
  description: "Selection outer/inner glow",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "selection--range--border",
  description: "Default select range/container border",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.blue400
  }
}, {
  name: "semantic--error--background",
  description: "Used on light backgrounds like banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.red75,
    "ursa-light": _ursaColors.colors.red50
  }
}, {
  name: "semantic--error--background--active",
  description: "",
  value: {
    "lodestar-light": lodestarColors.dangerLight20,
    "ursa-light": _ursaColors.colors.red100
  }
}, {
  name: "semantic--error--background--hover",
  description: "",
  value: {
    "lodestar-light": lodestarColors.dangerLight20,
    "ursa-light": _ursaColors.colors.red75
  }
}, {
  name: "semantic--error--border",
  description: "Background color for elements that present critical information",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.red500
  }
}, {
  name: "semantic--error--icon",
  description: "Used for icons",
  value: {
    "lodestar-light": _ursaColors.colors.red600,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "semantic--error--text",
  description: "Used on light backgrounds like banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.red900,
    "ursa-light": _ursaColors.colors.red800
  }
}, {
  name: "semantic--error--text-inline",
  description: "Used for input validation",
  value: {
    "lodestar-light": _ursaColors.colors.red600,
    "ursa-light": _ursaColors.colors.red600
  }
}, {
  name: "semantic--info--background",
  description: "Backgrounds for banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.azure75,
    "ursa-light": _ursaColors.colors.blue50
  }
}, {
  name: "semantic--info--background--active",
  description: "",
  value: {
    "lodestar-light": lodestarColors.infoLight20,
    "ursa-light": _ursaColors.colors.blue100
  }
}, {
  name: "semantic--info--background--hover",
  description: "",
  value: {
    "lodestar-light": lodestarColors.infoLight20,
    "ursa-light": _ursaColors.colors.blue75
  }
}, {
  name: "semantic--info--border",
  description: "Background color for elements that inform the user of some information",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.azure500
  }
}, {
  name: "semantic--info--icon",
  description: "Used for icons",
  value: {
    "lodestar-light": _ursaColors.colors.azure600,
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "semantic--info--text",
  description: "Used on light backgrounds like banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.azure900,
    "ursa-light": _ursaColors.colors.blue800
  }
}, {
  name: "semantic--info--text-inline",
  description: "Used for input validation",
  value: {
    "lodestar-light": _ursaColors.colors.azure600,
    "ursa-light": _ursaColors.colors.blue500
  }
}, {
  name: "semantic--success--background",
  description: "Used on light backgrounds like banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.mint50,
    "ursa-light": _ursaColors.colors.green50
  }
}, {
  name: "semantic--success--background--active",
  description: "",
  value: {
    "lodestar-light": lodestarColors.successLight20,
    "ursa-light": _ursaColors.colors.green100
  }
}, {
  name: "semantic--success--background--hover",
  description: "",
  value: {
    "lodestar-light": lodestarColors.successLight20,
    "ursa-light": _ursaColors.colors.green75
  }
}, {
  name: "semantic--success--border",
  description: "Background color for elements that present a favorable outcome",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.green500
  }
}, {
  name: "semantic--success--icon",
  description: "Used for icons",
  value: {
    "lodestar-light": _ursaColors.colors.mint500,
    "ursa-light": _ursaColors.colors.green600
  }
}, {
  name: "semantic--success--text",
  description: "Used on light backgrounds like banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.mint900,
    "ursa-light": _ursaColors.colors.green800
  }
}, {
  name: "semantic--success--text-inline",
  description: "Used for input validation",
  value: {
    "lodestar-light": _ursaColors.colors.mint600,
    "ursa-light": _ursaColors.colors.green600
  }
}, {
  name: "semantic--warning--background",
  description: "Used on light backgrounds like banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.gold75,
    "ursa-light": _ursaColors.colors.gold100
  }
}, {
  name: "semantic--warning--background--active",
  description: "",
  value: {
    "lodestar-light": lodestarColors.warningLight20,
    "ursa-light": _ursaColors.colors.gold300
  }
}, {
  name: "semantic--warning--background--hover",
  description: "",
  value: {
    "lodestar-light": lodestarColors.warningLight20,
    "ursa-light": _ursaColors.colors.gold200
  }
}, {
  name: "semantic--warning--border",
  description: "Background color for elements that provide caution",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.gold500
  }
}, {
  name: "semantic--warning--icon",
  description: "Used for icons",
  value: {
    "lodestar-light": _ursaColors.colors.gold700,
    "ursa-light": _ursaColors.colors.gold800
  }
}, {
  name: "semantic--warning--text",
  description: "Used on light backgrounds like banners and toasts",
  value: {
    "lodestar-light": _ursaColors.colors.gold900,
    "ursa-light": _ursaColors.colors.gold900
  }
}, {
  name: "semantic--warning--text-inline",
  description: "Used for input validation",
  value: {
    "lodestar-light": _ursaColors.colors.gold700,
    "ursa-light": _ursaColors.colors.gold800
  }
}, {
  name: "slate--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "slate--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "slate--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate100
  }
}, {
  name: "slate--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate75
  }
}, {
  name: "slate--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate300
  }
}, {
  name: "slate--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate800
  }
}, {
  name: "slate--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate500
  }
}, {
  name: "surface--border",
  description: "Default surface divider line",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "surface--canvas--background",
  description: "Default canvas surface background color",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.slate25
  }
}, {
  name: "surface--canvas--border",
  description: "top of work surface line",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "surface--canvas--border-scroll",
  description: "Scroll border when scrolling below fixed areas like headers.",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate100
  }
}, {
  name: "surface--canvas--divider",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate75
  }
}, {
  name: "surface--canvas--text",
  description: "Default canvas surface text color",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate700
  }
}, {
  name: "surface--work--background",
  description: "Default work surface background color",
  value: {
    "lodestar-light": lodestarColors.neutralLight40,
    "ursa-light": _ursaColors.colors.neutral00
  }
}, {
  name: "surface--work--background--hint",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral25
  }
}, {
  name: "surface--work--divider",
  description: "column header line",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral50
  }
}, {
  name: "surface--work--divider-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral75
  }
}, {
  name: "surface--work--divider-scroll",
  description: "scroll or column freeze line",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.slate50
  }
}, {
  name: "surface--work--text",
  description: "Default work surface text color",
  value: {
    "lodestar-light": lodestarColors.neutralDark40,
    "ursa-light": _ursaColors.colors.neutral800
  }
}, {
  name: "surface--work--text--inactive",
  description: "Used for readonly form fields sometimes",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral400
  }
}, {
  name: "surface--work--text--inactive-hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.neutral500
  }
}, {
  name: "teal--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.teal400
  }
}, {
  name: "teal--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.teal50
  }
}, {
  name: "teal--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.teal100
  }
}, {
  name: "teal--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.teal75
  }
}, {
  name: "teal--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.teal300
  }
}, {
  name: "teal--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.teal800
  }
}, {
  name: "teal--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.teal600
  }
}, {
  name: "violet--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.violet300
  }
}, {
  name: "violet--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.violet50
  }
}, {
  name: "violet--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.violet100
  }
}, {
  name: "violet--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.violet75
  }
}, {
  name: "violet--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.violet400
  }
}, {
  name: "violet--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.violet800
  }
}, {
  name: "violet--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.violet500
  }
}, {
  name: "yellow--background",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.yellow600
  }
}, {
  name: "yellow--background-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.yellow100
  }
}, {
  name: "yellow--background-alt--active",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.yellow300
  }
}, {
  name: "yellow--background-alt--hover",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.yellow200
  }
}, {
  name: "yellow--base",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.yellow500
  }
}, {
  name: "yellow--text",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.yellow900
  }
}, {
  name: "yellow--text-alt",
  description: "",
  value: {
    "lodestar-light": "",
    "ursa-light": _ursaColors.colors.yellow800
  }
}];
exports.colorTokens = colorTokens;
//# sourceMappingURL=color-tokens.js.map